const SadFaceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <circle cx="24" cy="24" r="24" fill="#FFD9D4" />
      <mask
        id="mask0_2515_55936"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="28"
        height="28"
      >
        <rect
          x="10.6665"
          y="10.6666"
          width="26.6667"
          height="26.6667"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2515_55936)">
        <path
          d="M27.8892 22.8889C28.3521 22.8889 28.7456 22.7269 29.0697 22.4028C29.3938 22.0787 29.5558 21.6852 29.5558 21.2222C29.5558 20.7593 29.3938 20.3658 29.0697 20.0417C28.7456 19.7176 28.3521 19.5556 27.8892 19.5556C27.4262 19.5556 27.0327 19.7176 26.7086 20.0417C26.3845 20.3658 26.2225 20.7593 26.2225 21.2222C26.2225 21.6852 26.3845 22.0787 26.7086 22.4028C27.0327 22.7269 27.4262 22.8889 27.8892 22.8889ZM20.1114 22.8889C20.5743 22.8889 20.9679 22.7269 21.2919 22.4028C21.616 22.0787 21.778 21.6852 21.778 21.2222C21.778 20.7593 21.616 20.3658 21.2919 20.0417C20.9679 19.7176 20.5743 19.5556 20.1114 19.5556C19.6484 19.5556 19.2549 19.7176 18.9308 20.0417C18.6068 20.3658 18.4447 20.7593 18.4447 21.2222C18.4447 21.6852 18.6068 22.0787 18.9308 22.4028C19.2549 22.7269 19.6484 22.8889 20.1114 22.8889ZM24.0003 25.6667C22.741 25.6667 21.5975 26.0232 20.5697 26.7361C19.5419 27.4491 18.7966 28.3889 18.3336 29.5556H20.1669C20.5743 28.8704 21.116 28.3287 21.7919 27.9306C22.4679 27.5324 23.204 27.3334 24.0003 27.3334C24.7966 27.3334 25.5327 27.5324 26.2086 27.9306C26.8845 28.3287 27.4262 28.8704 27.8336 29.5556H29.6669C29.204 28.3889 28.4586 27.4491 27.4308 26.7361C26.403 26.0232 25.2595 25.6667 24.0003 25.6667ZM24.0003 35.1111C22.4632 35.1111 21.0188 34.8195 19.6669 34.2361C18.3151 33.6528 17.1392 32.8611 16.1392 31.8611C15.1392 30.8611 14.3475 29.6852 13.7642 28.3334C13.1808 26.9815 12.8892 25.5371 12.8892 24C12.8892 22.463 13.1808 21.0185 13.7642 19.6667C14.3475 18.3148 15.1392 17.1389 16.1392 16.1389C17.1392 15.1389 18.3151 14.3472 19.6669 13.7639C21.0188 13.1806 22.4632 12.8889 24.0003 12.8889C25.5373 12.8889 26.9818 13.1806 28.3336 13.7639C29.6855 14.3472 30.8614 15.1389 31.8614 16.1389C32.8614 17.1389 33.653 18.3148 34.2364 19.6667C34.8197 21.0185 35.1114 22.463 35.1114 24C35.1114 25.5371 34.8197 26.9815 34.2364 28.3334C33.653 29.6852 32.8614 30.8611 31.8614 31.8611C30.8614 32.8611 29.6855 33.6528 28.3336 34.2361C26.9818 34.8195 25.5373 35.1111 24.0003 35.1111ZM24.0003 32.8889C26.4818 32.8889 28.5836 32.0278 30.3058 30.3056C32.028 28.5834 32.8892 26.4815 32.8892 24C32.8892 21.5185 32.028 19.4167 30.3058 17.6945C28.5836 15.9722 26.4818 15.1111 24.0003 15.1111C21.5188 15.1111 19.4169 15.9722 17.6947 17.6945C15.9725 19.4167 15.1114 21.5185 15.1114 24C15.1114 26.4815 15.9725 28.5834 17.6947 30.3056C19.4169 32.0278 21.5188 32.8889 24.0003 32.8889Z"
          fill="#EA3D29"
        />
      </g>
    </svg>
  )
}

export default SadFaceIcon
